import { render, staticRenderFns } from "./WordCloudGroupingToggler.vue?vue&type=template&id=5dc52aa4&scoped=true&"
import script from "./WordCloudGroupingToggler.vue?vue&type=script&lang=js&"
export * from "./WordCloudGroupingToggler.vue?vue&type=script&lang=js&"
import style0 from "./WordCloudGroupingToggler.vue?vue&type=style&index=0&id=5dc52aa4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc52aa4",
  null
  
)

export default component.exports